import { combineReducers } from '@reduxjs/toolkit';
import { detailSlice } from './detailSlice';
import { listSlice } from './listSlice';
import { menuDetailSlice } from './menuDetailSlice';
import { menuRegistrationSlice } from './menuRegistrationSlice';
import { registrationSlice } from './registrationSlice';

export const menuCategoryReducer = combineReducers({
  list: listSlice.reducer,
  registration: registrationSlice.reducer,
  detail: detailSlice.reducer,
  menuRegistration: menuRegistrationSlice.reducer,
  menuDetail: menuDetailSlice.reducer,
});
